class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll("button[data-color]").forEach((button) => {
      button.addEventListener("click", this.handleColorChange.bind(this));
    });

    this.mainImage = this.querySelector("[data-main-product-card-image]");
    this.variantImages = this.querySelector("[data-product-card-images]");
    this.productCardLinks = this.querySelectorAll("[data-product-card-link]");
  }

  handleColorChange(event) {
    const button = event.target;
    const color = button.getAttribute("data-color");
    const variantId = button.getAttribute("data-variant-id");
    const variantImage = this.querySelector(`[data-color-id="${color}"]`);

    if (this.mainImage && variantImage) {
      this.mainImage.innerHTML = variantImage.innerHTML;
    }

    if (this.productCardLinks && variantId) {
      this.productCardLinks.forEach((link) => {
        const currentUrl = new URL(
          `${window.origin}${link.getAttribute("href")}`
        );
        const params = new URLSearchParams(currentUrl.search);

        params.set("variant", variantId);

        link.setAttribute(
          "href",
          `${currentUrl.pathname}?${params.toString()}`
        );
      });
    }

    const activeButton = this.querySelector("button[data-color].active");

    activeButton.classList.remove(
      "active",
      "ring-1",
      "ring-border",
      "hover:ring-black"
    );
    button.classList.add(
      "active",
      "ring-1",
      "ring-primary",
      "hover:ring-black"
    );
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
